import { Component, OnDestroy, OnInit } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
import { CountryCode, CountryCodes } from 'src/app/constants/countrycodes';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, OnDestroy  {
  registrationForm: FormGroup;
  isRegistrationError: boolean = false;
  registrationMsg: string;
  registrationErrorMsg: string;
  registrationProcessInitiated: boolean = true;
  registrationService_: any;
  showSuccessPane: boolean;
  googleauthuri: SafeResourceUrl;
  countryCodes: Array<CountryCode>;
  postVerificationReturnUrl: string;

  constructor(private registrationService: UseraccessserviceService, private router: Router, private headerinfo: ComponentheaderService,private util: UtilService,
    private activatedroute: ActivatedRoute, private toaster: ToastrService, private sanitizer: DomSanitizer) {
    this.registrationService_ = registrationService;
    this.googleauthuri = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.ImpataAppDomainUrl}/googleauth`);
    this.registrationForm = new FormGroup({
      fullname: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(64),
        Validators.pattern(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]+$/
        )
      ]),
      cpassword: new FormControl('', [Validators.required, this.passwordMatchValidator()]),
      phone: new FormControl('', [Validators.required, this.phoneNumberValidator()]),
      countrycode: new FormControl('', Validators.required),
    });
    this.countryCodes = CountryCodes
    this.registrationForm.get('countrycode').setValue("+234");
    this.registrationForm.get('password')?.valueChanges.subscribe(() => {
      this.registrationForm.get('cpassword')?.updateValueAndValidity();
    });
  }

  passwordMatchValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!group.value) 
        return null;
     
      const password = this.registrationForm.get('password')?.value;
      const confirm = group.value;
      if (!password || !confirm) return null;
      return password === confirm ? null : { passwordMismatch: true };
    }
  }

  updateLoadScreen(val: boolean) {
    this.registrationService.isLoading = val;
  }
  
  async OnSubmit() {
    this.updateLoadScreen(true);
    try{
      if(this.registrationForm.valid){
        let timezonename = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let timezone = (new Date().getTimezoneOffset() / 60);
        this.isRegistrationError = false;
        let phone = this.util.reFormatNGorUKPhoneNumber(this.registrationForm.get('phone').value, this.registrationForm.get('countrycode').value);
        var data: any = await this.registrationService.userRegistration(this.registrationForm.get('fullname').value, this.registrationForm.get('password').value,
         this.registrationForm.get('email').value, this.registrationForm.get('countrycode').value, phone, timezone, timezonename, this.postVerificationReturnUrl).toPromise().catch((err) => {
          this.isRegistrationError = true;
          this.registrationErrorMsg = 'An error occured during registration';
        }).finally(() => {
          this.updateLoadScreen(false)
        });
        this.registrationMsg = data  
        this.showSuccessPane = !this.isRegistrationError;
      }
    }
    catch(error){
      console.error(error);
    }
    finally{
      this.updateLoadScreen(false);
    }
  }

  ngOnInit(): void {
    this.headerinfo.setPageTitle('Register');
    this.postVerificationReturnUrl = this.activatedroute.snapshot.queryParams.goto;

    window.addEventListener('message', this.receiveCredMessage.bind(this), false);
  }

  async receiveCredMessage(event: MessageEvent){
    if (event.origin !== `${environment.ImpataAppDomainUrl}` && event.data.type !== 'GoogleCredentials') {
      return;
    }
    if (event.data.payload){
      try {
        this.registrationService.userGoogleAuthentication(event.data.payload).subscribe(
          (data) => {
            this.navigateAfterGoogleAuth(data['token'], data['email']);
          }
        );
      } catch (error) {
        console.error("Request failed:", error);
      }
    }
  }

  navigateAfterGoogleAuth(token: string, email: string){
    try {
      this.registrationService.updateUserPrivateSchool(email).toPromise();
      window.location.href = `/?token=${token}`;
    } catch (error) {
      console.error("Request failed:", error);
    }
  }

  onCountryCodeChange() {
    const phoneControl = this.registrationForm.get('phone');
    if (phoneControl) {
      phoneControl.markAsTouched();
      phoneControl.updateValueAndValidity(); 
    }
  }
  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) 
        return null;
      let number = this.util.reFormatNGorUKPhoneNumber(control.value, this.registrationForm.get('countrycode').value);
      const isValid = this.util.getPhoneNumberRegexPattern(this.registrationForm.get('countrycode').value, number[0]).test(number);
      return isValid ? null : { invalidPhoneNumber: { value: control.value } };
    };
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.receiveCredMessage);
  }
}
